"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Event = require("../generated/Event.js");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLDetailsElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLDetailsElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLDetailsElementImpl);

  function HTMLDetailsElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLDetailsElementImpl);

    _this = _super.call(this, args, privateData);
    _this._taskQueue = null;
    return _this;
  }

  _createClass(HTMLDetailsElementImpl, [{
    key: "_dispatchToggleEvent",
    value: function _dispatchToggleEvent() {
      this._taskQueue = null;

      this._dispatch(Event.createImpl(["toggle", {
        bubbles: false,
        cancelable: false
      }], {
        isTrusted: true
      }));
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLDetailsElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (name === "open" && this._taskQueue === null) {
        // Check that the attribute is added or removed, not merely changed
        if (value !== oldValue && value !== null && oldValue === null || value === null && oldValue !== null) {
          this._taskQueue = setTimeout(this._dispatchToggleEvent.bind(this), 0);
        }
      }
    }
  }]);

  return HTMLDetailsElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLDetailsElementImpl
};